import React, { useState } from "react"
import { Button, Tag, Flex, Card } from "antd"
import { SyncOutlined } from "@ant-design/icons"
import AvailabilityModal from "./modal/AvailabilityModal"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import WithEmptyStateWrapper from "ui/WithEmptyStateWrapper"
import NoAvailability from "ui/Icon/DSIcon/NoAvailability"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { colors } from "themes/variables"

const Availability = ({ availability = {} }) => {
  const { currentRange = "", otherRange = "", schedule = [] } = availability
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const { t } = useTranslation()

  const handleEdit = () => {
    setIsEditModalOpen(true)
  }

  const handleSave = () => {
    // TODO: Save availability data
    console.log("Save availability")
    setIsEditModalOpen(false)
  }

  return (
    <Flex vertical gap={16} className={styles.container}>
      {/* Header */}
      <Flex align="center" justify="space-between" className={styles.header}>
        <h2 className={styles.title}>{t("crewMember.availability.title")}</h2>
        <Button type="link" onClick={handleEdit} className={styles.editButton}>
          Edit
        </Button>
      </Flex>

      {/* Date Range Filters */}
      <Flex gap={8} align="center" className={styles.filters}>
        {otherRange && (
          <Tag className={styles.inactiveChip}>
            <span>{otherRange}</span>
            <SyncOutlined className={styles.rotateIcon} />
          </Tag>
        )}
        {currentRange && (
          <Tag className={styles.activeChip}>
            <span>{currentRange}</span>
            <SyncOutlined className={styles.rotateIconActive} />
          </Tag>
        )}
      </Flex>
      <WithEmptyStateWrapper
        name="No Availability"
        hasItems={schedule.length > 0}
        fallback={
          <Card className="py-5xl">
            <Flex vertical justify="center" align="center" gap={12}>
              <NoAvailability />
              <Text color={colors.textPrimary} weight="semibold">
                {t("crewMember.availability.emptyState.title")}
              </Text>
              <Text color={colors.textSecondaryDark}>
                {t("crewMember.availability.emptyState.subtitle")}
              </Text>
            </Flex>
          </Card>
        }
      >
        {/* Schedule */}
        <Flex vertical gap={4} className={styles.schedule}>
          {schedule.map((item) => {
            const hasTime = item.times && item.times.length > 0
            const isInactive = !hasTime

            return (
              <Flex key={`${item.day}-${item.times?.join("-")}`} align="center" gap={8} className={styles.scheduleRow}>
                <div className={`${styles.dayLabel} ${isInactive ? styles.dayInactive : ""}`}>{item.day}</div>
                <Flex gap={12} wrap="wrap" align="center" className={styles.times}>
                  {hasTime ? (
                    item.times.map((time, timeIndex) => (
                      <span key={timeIndex} className={styles.timeText}>
                        {time}
                        {timeIndex < item.times.length - 1 && ","}
                      </span>
                    ))
                  ) : (
                    <span className={styles.noTime}>&nbsp;</span>
                  )}
                </Flex>
              </Flex>
            )
          })}
        </Flex>
      </WithEmptyStateWrapper>
      {/* Edit Availability Modal */}
      <AvailabilityModal
        open={isEditModalOpen}
        onCancel={() => setIsEditModalOpen(false)}
        onSave={handleSave}
        mode="edit"
        initialData={[
          { id: 1, number: 1, data: {} },
          { id: 2, number: 2, data: {} }
        ]}
      />
    </Flex>
  )
}

Availability.propTypes = {
  availability: PropTypes.shape({
    currentRange: PropTypes.string,
    otherRange: PropTypes.string,
    schedule: PropTypes.arrayOf(
      PropTypes.shape({
        day: PropTypes.string,
        times: PropTypes.arrayOf(PropTypes.string)
      })
    )
  })
}

export default Availability
